<script lang="ts" setup>
import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';
import { computed } from 'vue';
import { usePolicyStore } from '@/entities/Policy';
import { GA_EVENTS, useGoogleAnalytics } from '@/shared/analytics';

interface HotlineButtonProps {
  title?: string;
  text?: string;
  phone: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
}

const props = withDefaults(defineProps<HotlineButtonProps>(), {
  variant: 'primary',
  title: '',
  text: '',
});

const normalizedPhone = computed(() => {
  return props.phone.replaceAll(' ', '');
});

const gaService = useGoogleAnalytics();
const policyStore = usePolicyStore();

function clickEventCallUs() {
  gaService.send(GA_EVENTS.CLICK_CALLUS, {
    ...(props.title && { title: props.title }),
    ...(props.text && { title: props.text }),
    policy_id: policyStore.state.policyId,
  });
}
</script>

<template>
  <a :href="`tel:${normalizedPhone}`" class="hotline-link" data-test="hotline-phone">
    <ButtonQC size="medium" class="hotline-btn" :variant="variant" @click="clickEventCallUs">
      {{ $t('qic.help.hotline') }}
    </ButtonQC>
  </a>
</template>

<style lang="scss" scoped>
@use './HotlineButton';
</style>
